import React, { useCallback } from 'react';
import {
   Input,
   InputGroup,
   InputGroupAddon,
   InputGroupText,
} from 'reactstrap';
import PropTypes from 'prop-types';
import withInputErrorMessage from '../withInputErrorMessage';
import withNumberInput from './withNumberInput';

const PercentageInput = (props) => {
   // Stops 'e' from breaking the input by ignoring the e input
   const handleKeyDown = useCallback((event) => {
      if (event?.key === 'e') {
         event.preventDefault();
      }
   }, []);

   const onInputChange = (event) => {
      if (event.target.value > props.max) {
         return;
      } else if (event.target.value < props.min) {
         return;
      }
      props.onChange(event);
   };


   return (
      <InputGroup>
         <Input
            onKeyDown={ handleKeyDown }
            type='number'
            name={ props.name }
            onChange={ onInputChange }
            onBlur={ props.onBlur }
            value={ props.isDisabled && props.isValueHiddenWhenDisabled ? '' : props.value }
            disabled={ props.isDisabled }
            className={ props.className }
         />
         <InputGroupAddon addonType='append'>
            <InputGroupText>%</InputGroupText>
         </InputGroupAddon>
      </InputGroup>
   );
};

PercentageInput.propTypes = {
   name: PropTypes.string.isRequired,
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onChange: PropTypes.func.isRequired,
   onBlur: PropTypes.func.isRequired,
   isDisabled: PropTypes.bool,
   isValueHiddenWhenDisabled: PropTypes.bool,
   className: PropTypes.string,
   min: PropTypes.number.isRequired,
   max: PropTypes.number.isRequired,
};

PercentageInput.defaultProps = {
   value: '',
   isDisabled: false,
   isValueHiddenWhenDisabled: false,
   className: '',
   min: 0,
   max: 100,
};

export default withNumberInput(withInputErrorMessage(PercentageInput));
